import { Textarea } from 'core-components/library/inputs'
import { Radio } from 'core-components/library/radio'
import { Controller, ValidateInput, ValidationStatus } from 'core-components/library/validation'

import { configuration, IQuestion } from '../config'
import { IQuestionsProps } from '../models/ISurvey'

import styles from './Questions.module.scss'

export const Questions = ({
  survey,
  translations,
  onChange,
  changeAnswersValid,
}: IQuestionsProps) => {
  const config = configuration()

  const getAnswersContentByQuestion = (question: IQuestion, index: number) => {
    if (question.answersType === 'Radio') {
      return config.answers
        .filter((item) => item.questionKey === question.key)
        .map((answer) => {
          const value = survey[question.key - 1]?.AnswerKey

          return (
            <div key={`Question-${answer.questionKey}Answer-${answer.key}`}>
              <Radio
                margin={'sm'}
                checked={value === answer.key}
                value={`${value}`}
                label={translations.get(answer.translationKey)}
                onChange={() => onChange(question.key, answer.key, '')}
              />
              {answer.needElaborate && value === answer.key && (
                <Textarea
                  classes={{ root: styles.textarea }}
                  placeholder={'Please elaborate'}
                  value={survey[index]?.Elaboration || ''}
                  onChange={(newValue) => onChange(question.key, answer.key, newValue)}
                  rows={4}
                />
              )}
            </div>
          )
        })
    }
    if (question.answersType === 'ValidateInput') {
      return (
        <ValidateInput
          classes={{
            validatorClasses: {
              root: styles.input,
            },
          }}
          checkFn={question.validateFunction ? question.validateFunction : null}
          value={survey[index]?.Elaboration || ''}
          placeholder={question.placeholder}
          onChange={(value) => onChange(question.key, 1, value)}
        />
      )
    }

    return null
  }

  return (
    <Controller
      onValidationStatusChange={(newStatus) => {
        changeAnswersValid(newStatus.status === ValidationStatus.Valid)
      }}
    >
      {config.questions.map((question, index) => {
        return (
          <div className={styles.root} key={index}>
            <div className={styles.index}>{index + 1}</div>
            <div className={styles.content}>
              <div className={styles.content__header}>
                {translations.get(question.translationKey)}
              </div>
              <div className={styles.content__body}>
                {getAnswersContentByQuestion(question, index)}
              </div>
            </div>
          </div>
        )
      })}
    </Controller>
  )
}
